import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { isManageScriptListLoadDone } from 'api/loading/selectors';

import ManageMapContainer from 'mapping/ManageMapContainer';
import DisplayPanel from 'common/DisplayPanel';
import Spinner from 'common/Spinner';
import ManageDisplayPanel from 'manage/ManageDisplayPanel';

const ManageBody = ({
  isActiveFieldLoading,
  linkToCreateRoute,
  onClickCreatePrescriptionTrigger
}) => {

  const isReady = useSelector(isManageScriptListLoadDone);

  return (
    <div className='vra-manage-body'>
      {!isReady && <Spinner />}
      <DisplayPanel isLoading={isActiveFieldLoading}>
        <ManageDisplayPanel
          linkToCreateRoute={linkToCreateRoute}
          onClickCreatePrescriptionTrigger={onClickCreatePrescriptionTrigger}
        />
      </DisplayPanel>
      <ManageMapContainer/>
    </div>);
};
ManageBody.propTypes = {
  isActiveFieldLoading: PropTypes.bool.isRequired,
  linkToCreateRoute: PropTypes.string.isRequired,
  onClickCreatePrescriptionTrigger: PropTypes.func.isRequired,
  isManageScriptListLoadDone: PropTypes.bool.isRequired
};
export default ManageBody;
